<template>
  <div class="row">
    <div class="col-12">
      <m-input
        class="search-form-field"
        v-model="search.PRICENAME"
        nolabel
        :placeholder="$t('search.pricename')"
      ></m-input>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: {
        PRICENAME: null,
      },
    };
  },

  methods: {
    getSearch() {
      return this.search;
    },
    clearSearch() {
      this.search = {
        PRICENAME: null,
      };
    },
  },
};
</script>

<style></style>
